import { DIGITAL_DELIVERY_ONLY_MESSAGE } from 'constants/siteMessages';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/address/addressformats/digitalDeliveryOnlyAddress.scss';

const DigitalDeliveryOnlyAddress = () => (
  <div>
    <Row desktopOnly={true}>
      <RowSpan span="4">
        <div className={css.inactiveTitleBar}>
          <div className={css.titleWrapper}>
            <div className={css.stepIndex}>
              <h3>1</h3>
            </div>
            <h4 className={css.title}>Shipping address</h4>
          </div>
        </div>
      </RowSpan>
      <RowSpan span="8">
        {DIGITAL_DELIVERY_ONLY_MESSAGE}
      </RowSpan>
    </Row>
    <div className={css.smallScreenOnly}>
      {DIGITAL_DELIVERY_ONLY_MESSAGE}
    </div>
  </div>
);

export default DigitalDeliveryOnlyAddress;
